import AsoHeader from "../../../components/Aso/Header";
import FaceComparison from "../../../components/FaceComparison";

export const ComparacaoFacial = () => {
  return(
    <>
      <AsoHeader />
      <FaceComparison />
    </>
  );
}